import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ContentBlock from "../Components/ContentBlock";
import TopNavBar from "../Components/TopNavBar";
import Footer from "../Components/Footer";
import { FacebookProvider, Page } from 'react-facebook';
import SiteSettingsService from "../Api/SiteSettingsService";


class Apie extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pageName: 'Apie',
            businessContacts: [],
            contactAddress: ''
        }
    }

    componentDidMount() {
        SiteSettingsService.getSiteSettings().then((response) => {
            var businessContacts = [];
            var contactAddress = '';
            response.data.forEach(element => {
                switch (element.Name) {
                    case 'contact_address': 
                        businessContacts.push({ "Adresas": element.Value });
                        contactAddress = element.Value;
                        break;
                    case 'contact_email': businessContacts.push({ "El. paštas": element.Value }); break;
                    case 'contact_phone': businessContacts.push({ "Tel.": element.Value }); break;
                    case 'company_name': businessContacts.push({ "Įmonės pavadinimas": element.Value }); break;
                    case 'company_code': businessContacts.push({ "Įmonės kodas": element.Value }); break;
                }
            });
            this.setState({ businessContacts: businessContacts, contactAddress: contactAddress });
            // Commenting out the map script loading
            // this.setState({ businessContacts: businessContacts, contactAddress: contactAddress }, this.loadMapScript);
        });
    }

    // Commenting out the map script loading function
    // loadMapScript = () => {
    //     const script = document.createElement("script");
    //     script.src = "http://www.bing.com/api/maps/mapcontrol?callback=GetMap&key=AgR4htd0xBsrwMNA8uptK1iNp24WApsXY0eMEq88_ygXU_Kyf7nDHMk7PJHn2BMf";
    //     script.async = true;
    //     document.body.appendChild(script);

    //     window.GetMap = this.GetMap;
    // }

    // Commenting out the GetMap function
    // GetMap = () => {
    //     var map = new Microsoft.Maps.Map('#myMap');
    //     var searchManager = new Microsoft.Maps.Search.SearchManager(map);
    //     var requestOptions = {
    //         bounds: map.getBounds(),
    //         where: this.state.contactAddress,
    //         callback: function (answer, userData) {
    //             map.setView({ bounds: answer.results[0].bestView });
    //             var pushpin = new Microsoft.Maps.Pushpin(answer.results[0].location);
    //             map.entities.push(pushpin);
    //         }
    //     };
    //     searchManager.geocode(requestOptions);
    // }

    render() {

        const pageStyle = {
            backgroundImage: "url(apie-page-background.png)",
            height: '100vh',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
        };

        const kontaktaiStyle = {
            fontFamily: 'Sitka',
            fontStyle: 'normal',
            fontWeight: '400',
            textAlign: 'center',
        };

        return (
            <Container fluid style={pageStyle}>
                <TopNavBar activeRoute={6} />
                <Container>
                    <h1 className='page-title'>{this.state.pageName}</h1>
                    <ContentBlock>
                        <Row>
                            <Col md={6}>
                                <div className="about-us-block-title">
                                    <h2>Kontaktai</h2>
                                </div>
                                <div className="about-us-block">
                                    {this.state.businessContacts.map((item, index) => {
                                        return (
                                            <div key={index}>
                                                <span>{Object.keys(item)[0]}: </span>
                                                <span className="about-us-block-text">{Object.values(item)[0]}</span>
                                            </div>
                                        )
                                    }
                                    )}

                                </div>
                                <div>
                                    <FacebookProvider appId="705227591237138">
                                        <Page href="https://www.facebook.com" tabs="timeline" />
                                    </FacebookProvider>
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="about-us-block-title">
                                    <h2>Kaip mus rasti?</h2>
                                </div>
                                <div className="block-shadow">
                                    {/* Replacing the map with a static image */}
                                    <img src="Map.png" alt="Static Map" style={{ position: 'relative', width: '672px', height: '639px' }} />
                                </div>
                            </Col>
                        </Row>
                    </ContentBlock>
                </Container>
                <Footer></Footer>
            </Container>
        );
    }
}

export default Apie;